import * as modalActionsType from '@/constants/modalActionsType';

const initialState = {
  modalVisible: false,
  modalHeader: 'Numpad',
  modalTitle: null,
  value: '0.0',
  incrementValue: 0.1,
  maxValue: 50,
  minValue: 1,
  maxDigitAfterDecimal: 1,
  numpadMode: 'normal',
  unit: '',
  info: '',
  callback: null,
  validatorInput() {
    return {isValid: true};
  },

  popUpVisible: false,
  popUpTitle: 'Title',
  popUpText: 'Text',
  popUpButton: [],
  popUpQuestion: 'Question?',
  popUpHideCloseButton: false,

  keyboardVisible: false,
  keyboardValue: 'Text',
  keyboardTitle: 'Title',
  keyboardCallBack: undefined,
  keyboardCancel: undefined,
  keyboardPlaceholder: 'Placeholder',
  disableSymbols: false,
  overwriteFirstInput: false,
  max: 50,

  hardwareChekUpVisible: false,
  isHardwareCheckUpRunning: false,
  isHardwareCheckUpPaused: false,
  hardwareChekUpTitle: 'Hardware Check Up',
  hardwareCheckUpText:
    'Before running any cycle, please makes sure to check if all the hardware ready.\n\nDo you want to do hardware check up right now?',
  hardwareCheckUpButton: 'YESNO',
  yesText: 'Yes',
  noText: "No, I'll do it later",
  okText: 'Ok',

  hardwareList: '',
  errorMessage: '',
  currentHardwareCheckupState: 'Idle',

  loadSetupVisible: false,
};

export default function modalStore(state = initialState, action = {}) {
  switch (action.type) {
    case modalActionsType.SHOW_MODAL:
      if (action.value) {
        const {
          modalHeader,
          modalTitle,
          value,
          maxDigitAfterDecimal,
          incrementValue,
          minValue,
          maxValue,
          unit,
          callback,
          validatorInput,
          numpadMode,
          info,
        } = action.value;
        return {
          ...state,
          value,
          callback,
          modalVisible: true,
          modalHeader,
          modalTitle,
          maxValue: maxValue !== undefined ? maxValue : initialState.maxValue,
          minValue: minValue !== undefined ? minValue : initialState.minValue,
          maxDigitAfterDecimal:
            maxDigitAfterDecimal !== undefined ? maxDigitAfterDecimal : initialState.maxDigitAfterDecimal,
          incrementValue: incrementValue !== undefined ? incrementValue : initialState.incrementValue,
          validatorInput:
            validatorInput === undefined
              ? function () {
                  return {isValid: true};
                }
              : validatorInput,
          numpadMode: numpadMode === undefined ? initialState.numpadMode : numpadMode,
          unit: unit === undefined ? '' : unit,
          info: info === undefined ? '' : info,
        };
      }

      break;

    case modalActionsType.HIDE_MODAL:
      return {
        ...state,
        modalVisible: false,
        modalHeader: '',
        modalTitle: null,
        value: '0.0',
        incrementValue: 0.1,
        maxValue: 50,
        minValue: 1,
        maxDigitAfterDecimal: 1,
        numpadMode: 'normal',
        unit: '',
        info: '',
        callback: null,
        validatorInput() {
          return {isValid: true};
        },
      };

    case modalActionsType.SHOW_POPUP:
      if (action.value) {
        const {popUpTitle, popUpText, popUpQuestion, popUpButton, popUpClose, popUpHideCloseButton} = action.value;
        return {
          ...state,
          popUpVisible: true,
          popUpTitle: popUpTitle === undefined ? '' : popUpTitle,
          popUpText: popUpText === undefined ? '' : popUpText,
          popUpQuestion: popUpQuestion === undefined ? '' : popUpQuestion,
          popUpButton: popUpButton === undefined ? [] : popUpButton,
          popUpClose,
          popUpHideCloseButton,
        };
      }

      break;

    case modalActionsType.HIDE_POPUP:
      return {
        ...state,
        popUpVisible: false,
        popUpTitle: '',
        popUpText: '',
        popUpQuestion: '',
        popUpButton: [],
        popUpHideCloseButton: false,
      };

    case modalActionsType.SHOW_KEYBOARD:
      if (action.value) {
        const {
          keyboardValue,
          keyboardTitle,
          keyboardCallBack,
          keyboardPlaceholder,
          disableSymbols,
          overwriteFirstInput,
          max,
          keyboardCancel,
        } = action.value;
        return {
          ...state,
          keyboardVisible: true,
          keyboardValue,
          keyboardTitle,
          keyboardCallBack,
          keyboardPlaceholder,
          overwriteFirstInput: overwriteFirstInput || false,
          max,
          keyboardCancel,
          disableSymbols,
        };
      }

      break;

    case modalActionsType.HIDE_KEYBOARD:
      return {
        ...state,
        keyboardVisible: false,
        keyboardValue: 'Text',
        keyboardTitle: 'Title',
        keyboardCallBack: undefined,
        keyboardPlaceholder: 'Placeholder',
        overwriteFirstInput: false,
        max: 50,
        keyboardCancel: undefined,
        disableSymbols: false,
      };

    case modalActionsType.SHOW_HARDWARE_CHECKUP:
      if (action.value) {
        const {
          isHardwareCheckUpRunning,
          hardwareChekUpTitle,
          hardwareCheckUpText,
          hardwareCheckUpButton,
          yesText,
          noText,
          okText,
        } = action.value;
        return {
          ...state,
          hardwareChekUpVisible: action.value.hardwareChekUpVisible,
          isHardwareCheckUpRunning:
            isHardwareCheckUpRunning !== undefined ? isHardwareCheckUpRunning : state.isHardwareCheckUpRunning,
          hardwareChekUpTitle: hardwareChekUpTitle !== undefined ? hardwareChekUpTitle : state.hardwareChekUpTitle,
          hardwareCheckUpText: hardwareCheckUpText !== undefined ? hardwareCheckUpText : state.hardwareCheckUpText,
          hardwareCheckUpButton:
            hardwareCheckUpButton !== undefined ? hardwareCheckUpButton : state.hardwareCheckUpButton, // yesOrNo or Ok
          yesText: yesText !== undefined ? yesText : state.yesText,
          noText: noText !== undefined ? noText : state.noText,
          okText: okText !== undefined ? okText : state.okText,
        };
      }

      break;

    case modalActionsType.RUN_HARDWARE_CHECK_UP:
      return {...state, isHardwareCheckUpRunning: action.value};

    case modalActionsType.PAUSED_HARDWARE_CHECK_UP:
      return {...state, isHardwareCheckUpPaused: action.value};

    case modalActionsType.UPDATE_HARDWARE_CHECK_UP_BUTTON:
      if (action.value) {
        const {hardwareCheckUpButton, yesText, noText, okText} = action.value;
        return {
          ...state,
          hardwareCheckUpButton:
            hardwareCheckUpButton !== undefined ? hardwareCheckUpButton : state.hardwareCheckUpButton, // yesOrNo or Ok
          yesText: yesText !== undefined ? yesText : state.yesText,
          noText: noText !== undefined ? noText : state.noText,
          okText: okText !== undefined ? okText : state.okText,
        };
      }

      break;

    case modalActionsType.UPDATE_HARDWARE_LIST:
      if (action.value) {
        return {...state, hardwareList: action.value};
      }
      break;

    case modalActionsType.UPDATE_HARDWARE_CHECK_UP_STATE:
      if (action.value) {
        return {...state, currentHardwareCheckupState: action.value};
      }
      break;

    case modalActionsType.SHOW_LOADSETUP:
      if (action.value) {
        return {
          ...state,
          loadSetupVisible: action.value.loadSetupVisible,
        };
      }

      break;

    default:
      return state;
  }

  return state;
}
